/**
 * Iliad metadata + config
 * 24 Books with actual stanza counts
 */

const bookMetadata = [
  { bookNum: 1, bookTitle: 'The Quarrel by the Ships', stanzas: 19 },
  { bookNum: 2, bookTitle: 'The Catalogue of Ships', stanzas: 25 },
  { bookNum: 3, bookTitle: 'The Duel', stanzas: 14 },
  { bookNum: 4, bookTitle: 'Agamemnon\'s Strategy', stanzas: 14 },
  { bookNum: 5, bookTitle: 'The Deeds of Diomedes', stanzas: 27 },
  { bookNum: 6, bookTitle: 'Hector and Andromache', stanzas: 16 },
  { bookNum: 7, bookTitle: 'The Duel of Ajax and Hector', stanzas: 14 },
  { bookNum: 8, bookTitle: 'The Battle by the Ships', stanzas: 17 },
  { bookNum: 9, bookTitle: 'The Embassy to Achilles', stanzas: 20 },
  { bookNum: 10, bookTitle: 'Dolon the Spy', stanzas: 15 },
  { bookNum: 11, bookTitle: 'The Great Deeds of Agamemnon', stanzas: 24 },
  { bookNum: 12, bookTitle: 'The Assault on the Wall', stanzas: 13 },
  { bookNum: 13, bookTitle: 'The Battle in the Place of the Ships', stanzas: 25 },
  { bookNum: 14, bookTitle: 'Juno\'s Stratagem', stanzas: 14 },
  { bookNum: 15, bookTitle: 'Neptune Aids the Greeks', stanzas: 21 },
  { bookNum: 16, bookTitle: 'The Exploits of Patroclus', stanzas: 25 },
  { bookNum: 17, bookTitle: 'The Battle for Patroclus', stanzas: 20 },
  { bookNum: 18, bookTitle: 'The Arms of Achilles', stanzas: 17 },
  { bookNum: 19, bookTitle: 'Achilles Reconciles with Agamemnon', stanzas: 11 },
  { bookNum: 20, bookTitle: 'The Battle of the Gods', stanzas: 14 },
  { bookNum: 21, bookTitle: 'Achilles Pursues the Trojans', stanzas: 16 },
  { bookNum: 22, bookTitle: 'The Death of Hector', stanzas: 16 },
  { bookNum: 23, bookTitle: 'The Funeral Games', stanzas: 25 },
  { bookNum: 24, bookTitle: 'The Ransoming of Hector', stanzas: 24 }
];

const BOOKS_WITH_ASSESSMENTS = new Set([1, 6, 9, 22, 24]);

// Build chapter array with 1:1 chunk-to-book mapping (chunk00 = Book 1, chunk01 = Book 2, etc.)
export const chapters = bookMetadata.map((book, index) => ({
  chapter_id: book.bookNum,
  chapt_num: book.bookNum,
  chapt_name: `Book ${book.bookNum}: ${book.bookTitle}`,
  subtitle: `Stanzas 1 - ${book.stanzas}`,
  stanzaRange: `1 - ${book.stanzas}`,
  hasAssessment: BOOKS_WITH_ASSESSMENTS.has(book.bookNum),
  chunk: `chunk${String(index).padStart(2, '0')}`
}));

const getChapterByChunk = (chunk) => chapters.find((ch) => ch.chunk === chunk);

export const config = {
  id: 'Iliad',
  displayName: 'The Iliad',
  author: 'Homer',
  coverImage: 'TheIliad.png',
  route: 'Iliad',
  type: 'epic',
  contentKey: 'Iliad',
  bookId: 'iliad',
  usesExternalLinks: false,
  features: {
    hints: false
  },

  getTitleForChunk: function(chunk) {
    const chapter = getChapterByChunk(chunk);
    return chapter ? chapter.chapt_name : 'The Iliad';
  },

  getSubtitle: function(fragmentRange, _level, _showCefrLevel, chunk) {
    const chapter = getChapterByChunk(chunk);
    if (chapter?.subtitle) {
      return chapter.subtitle;
    }
    if (fragmentRange?.start && fragmentRange?.end) {
      return `Stanzas ${fragmentRange.start} - ${fragmentRange.end}`;
    }
    return 'The Iliad';
  }
};

const book = { config, chapters };

export default book;
